import Reveal from "@/components/Reveal";
import { features } from "@/mocks/news";
import type { FeatureItem } from "@/mocks/types";

interface FeatureArchivesProps {
  onRead: (item: FeatureItem) => void;
}

export default function FeatureArchives({ onRead }: FeatureArchivesProps) {
  return (
    <section id="archive" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* intro */}
          <div className="lg:col-span-4">
            <Reveal>
              <div className="lg:sticky lg:top-24">
                <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.24em] text-primary-600">
                  <span className="h-px w-8 bg-primary-400"></span> Feature · 深度档案
                </p>
                <h2 className="mt-3 font-heading text-2xl font-black leading-tight tracking-tight text-foreground-900 md:text-[34px]">
                  不只吃瓜，<br />
                  也看懂瓜
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                  资源瓜怎么流传？未官宣行程如何泄露？我们用行业视角把这些“信息流”拆开，
                  让你知道一条爆料背后完整的链条，也学会分辨真假瓜。
                </p>
                <div className="mt-6 flex flex-col gap-2.5 border-l-2 border-primary-200 pl-4">
                  {[
                    "厘清资源瓜的传播路径",
                    "识别“为招商放风”的饼",
                    "理解空降情报的供应环节",
                    "学会分辨不同可信等级",
                  ].map((t) => (
                    <p key={t} className="flex items-center gap-2 text-sm text-foreground-700">
                      <i className="ri-checkbox-circle-line text-primary-500" aria-hidden="true"></i>
                      {t}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>

          {/* feature cards */}
          <div className="flex flex-col gap-6 lg:col-span-8">
            {features.map((f, i) => (
              <Reveal key={f.id} delay={i * 80}>
                <button
                  type="button"
                  onClick={() => onRead(f)}
                  className="group relative block w-full overflow-hidden rounded-3xl text-left"
                >
                  <div className="relative aspect-[16/8] overflow-hidden md:aspect-[16/7]">
                    <img
                      src={f.image}
                      alt={f.title}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/45 to-transparent"></div>
                    <span className="absolute left-4 top-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
                      <i className="ri-book-open-line text-sm" aria-hidden="true"></i>
                      深度解析
                    </span>
                    <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
                      <div className="flex items-center gap-2 text-[13px] text-background-200/90">
                        <span className="flex items-center gap-1.5">
                          <i className="ri-calendar-line" aria-hidden="true"></i>
                          {f.date}
                        </span>
                        <span className="h-3.5 w-px bg-background-50/30"></span>
                        <span className="flex items-center gap-1.5">
                          <i className="ri-time-line" aria-hidden="true"></i>
                          {f.readTime}
                        </span>
                        <span className="ml-auto hidden items-center gap-1.5 whitespace-nowrap text-background-50 transition-transform sm:inline-flex group-hover:translate-x-1">
                          全文阅读
                          <i className="ri-arrow-right-line" aria-hidden="true"></i>
                        </span>
                      </div>
                      <h3 className="mt-3 font-heading text-xl font-black leading-snug text-background-50 md:text-2xl">
                        {f.title}
                      </h3>
                      <p className="mt-2 line-clamp-1 text-sm text-background-200/90 md:line-clamp-2">{f.dek}</p>
                    </div>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}